export default {
  masterChef: {
    137: '0xD0023db30D1f4dB77e1049E79817B4D5dc571d15',
    80001: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  },  
  sousChef: {
    137: '0xD0023db30D1f4dB77e1049E79817B4D5dc571d15',
    80001: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  multiCall: {
    137: '0x95028E5B8a734bb7E2071F96De89BABe75be9C8E',
    80001: '',
  },
  vaultChef: {
    137: '0x2e620B2844E43004d095959A31B7ae9f9dbbb830',
    80001: '',
  },
  chainlinkOracle: {
    137: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
    80001: '',
  },
}
